<template>
  <spinner v-if="isLoading" fullScreen />
  <section v-else class="container-fluid">
    <header>
      <h3 class="title">{{guide.fields.displayName}}</h3>
    </header>
    <!--<v-expansion-panel>-->

      <!--&lt;!&ndash; top level documents-->
      <!--<v-expansion-panel-content v-for="document of guide.fields.documents" class="grey lighten-3">-->
        <!--<div slot="header">-->
          <!--<v-icon class="mr-4">question_answer</v-icon>-->
          <!--{{document.fields.title}}-->
        <!--</div>-->
        <!--<v-card>-->
          <!--<v-card-text v-html="renderDocument(document.fields.body)">-->
          <!--</v-card-text>-->
        <!--</v-card>-->
      <!--</v-expansion-panel-content>-->
      <!--&ndash;&gt;-->

    <!--&lt;!&ndash; sub categories &ndash;&gt;-->
      <!--<v-expansion-panel-content v-for="category of guide.fields.categories" class="blue-grey lighten-4 border-bottom border-dark">-->
        <!--<div slot="header" class=""><v-icon class="mr-4">folder_open</v-icon>{{category.fields.displayName}}</div>-->
        <!---->

      <!--</v-expansion-panel-content>-->

    <!--</v-expansion-panel>-->
    <v-expansion-panel popout>
      <v-expansion-panel-content v-for="(document, index) of documents" :key="document.sys.id">
        <div slot="header" class="text-info">
          {{index+1}}. {{document.fields.title}}
        </div>
        <!-- m4 video -->
        <v-container fluid grid-list-md class="" v-if="document.fields.video">
          <v-layout row justify-center class="white">
            <v-card class="border border-light z-depth-1 ma-1 elevation-1">
              <video controls :src="document.fields.video.fields.file.url" class="img-responsive" style="max-width: 760px"></video>
            </v-card>
          </v-layout>
        </v-container>

        <v-card>
          <v-card-text v-html="renderDocument(document.fields.body)">
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </section>
</template>
<script>
import Spinner from '@/components/Spinner';
import { fetchEntry, renderDocument, renderVideo } from '@/helpers/contentful';

export default {
  components: { Spinner },
  props: {
    id: String,
  },
  data() {
    return {
      guide: {},
      isLoading: false,
    };
  },
  async created () {
    this.fetchData();
  },
  watch: {
    '$route': 'fetchData'
  },
  computed: {
    documents() {
      return this.guide.fields.documents || [];
    }
  },
  mounted() {
    const markedjs = document.createElement('script');
    markedjs.setAttribute('src', 'https://cdn.jsdelivr.net/npm/marked/marked.min.js');
    document.head.appendChild(markedjs);

    this.$nextTick(() => {
      // wait for entire view to render
      // will trigger before contentful async load completes
    })
  },
  methods: {
    renderDocument,
    renderVideo,
    async fetchData () {
      this.isLoading = true;
      this.guide = await fetchEntry(this.id);
      this.isLoading = false;
    }
  }
};
</script>
<style lang="scss" scoped>

section.container-fluid header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}
section.container-fluid header .titles {
  flex: 1;
  display: flex;
  padding-bottom: 0;
}

section.container-fluid header .form-control {
  margin: 0;
  max-width: 300px;
}

section.container-fluid >>> hr {
  margin-top: 3rem !important;
}

section.container-fluid >>> h1 {
  margin: 5px 0 15px 0;
}

section.container-fluid >>> h2, >>> h3, >>> h4, >>> h5 {
  margin: 30px 0 15px 0;
}

section.container-fluid >>> p {
  margin-left: 5px;
  font-size: 12pt;
}

section.container-fluid >>> .contentful-asset {
  position: relative;
}

section.container-fluid >>> .contentful-asset .icon {
  position: absolute;
  top: 0px;
  left: 50%;
  font-size: 40px;
  color: #ffc107;
  text-shadow: 1px 1px 2px #000000;
}

section.container-fluid >>> .contentful-asset img {
  display:block;
  transition: transform .2s; /* Animation */
  //border: 1px solid #ddd;
  box-shadow: 0 0 5px #343436;
  border-radius: 2px;
  padding: 5px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 5px;
  margin-bottom: 20px;
}

section.container-fluid >>> .contentful-asset img.zoom:hover {
  transform: scale(1, 1);
  max-height:1000px !important;
  border-radius: 0px;
  padding: 0px;
}

section.container-fluid >>> .contentful-asset img.zoom:hover+.icon {
  display: none;
}

section.container-fluid >>> blockquote p {
  white-space: pre;
}

.video-container {
  position: relative;
  padding-bottom: 56.25%;
  padding-top: 30px; height: 0; overflow: hidden;
}

.video-container iframe,
.video-container object,
.video-container embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

/*  markdown table */
.markdown >>> > table {
  border: 1px solid #1C6EA4;
  background-color: #F4F4F4;
  width: 100%;
  text-align: left;
  border-collapse: collapse;
}
section.container-fluid  table td, table th {
  border: 1px solid #FFFFFF;
  padding: 3px 2px;
}
section.container-fluid  table tbody td {
  font-size: 13px;
}
section.container-fluid  table thead {
  background: #1C6EA4;
  border-bottom: 0px solid #444444;
}
 table thead th {
  font-size: 15px;
  font-weight: normal;
  color: #FFFFFF;
  text-align: left;
  border-left: 0px solid #D0E4F5;
}
 table thead th:first-child {
  border-left: none;
}

 table tfoot td {
  font-size: 14px;
}
 table tfoot .links {
  text-align: right;
}
 table tfoot .links a{
  display: inline-block;
  background: #1C6EA4;
  color: #FFFFFF;
  padding: 2px 8px;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Guide/Guide.vue